import { AsyncPipe, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ItemListResponse, Role } from '@models';
import { ResolveUserPipe } from '@pipes';
import { httpResource } from '@angular/common/http';
import { environment } from '@environment';
import { ListComponent } from '@components/list/list.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-role-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [
    ResolveUserPipe,
    AsyncPipe,
    DatePipe,
    RouterModule,

    MatListModule,
    MatIconModule,
    MatButtonModule,

    ListComponent,
  ],
})
export class RoleListComponent {
  roles = httpResource(() => `${environment.komainuHost}/role/?take=50`, {
    parse: (response: unknown) => {
      const roles = response as Role[];
      return {
        items: roles || [],
        count: roles?.length || 0,
      } as ItemListResponse<Role>;
    }
  });
}
